import React from "react";
import { Link } from "react-router-dom";
import appIcon from "../assets/gmail-collapse-all/icon-source.svg";
import tabGroupShareIcon from "../assets/tab-group-share/icon128.png";
import tinyJpgPngIcon from "../assets/tiny-jpg-png/icon-128.png";
import ChromeWebStoreButton from "../components/ChromeWebStoreButton";
import TabGroupShareStoreButton from "../components/TabGroupShareStoreButton";
import TinyJpgPngStoreButton from "../components/TinyJpgPngStoreButton";
import styles from "../InverluxApps.module.css";

const AppsHome = () => (
  <>
    <section className={styles.homeHero}>
      <div className={styles.contentWidth}>
        <div className={styles.homeHeroGrid}>
          <div>
            <p className={styles.eyebrow}>Browser utilities from Inverlux LLC</p>
            <h1>Inverlux Apps</h1>
            <p className={styles.heroLead}>
              Small, focused browser utilities designed to make everyday
              workflows faster and less frustrating.
            </p>
            <p className={styles.developedBy}>Developed by Inverlux LLC.</p>
            <a className={styles.primaryLink} href="#apps">
              Explore our apps
              <span aria-hidden="true">→</span>
            </a>
          </div>
          <div className={styles.focusPanel} aria-label="Our product principles">
            <span className={styles.focusGlow} aria-hidden="true" />
            <p>Thoughtful software for small, persistent problems.</p>
            <ul>
              <li>Focused by design</li>
              <li>Private by default</li>
              <li>Clear and dependable</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.section} id="apps">
      <div className={styles.contentWidth}>
        <div className={styles.sectionHeading}>
          <p className={styles.eyebrow}>Apps</p>
          <h2>Focused tools for your everyday browser workflows.</h2>
        </div>

        <article className={styles.productCard}>
          <img
            className={styles.productIcon}
            src={tinyJpgPngIcon}
            alt="Tiny JPG & PNG bear icon"
            width="120"
            height="120"
          />
          <div className={styles.productSummary}>
            <div className={styles.statusRow}>Chrome extension · Coming soon</div>
            <h3>Tiny JPG &amp; PNG</h3>
            <p>By Inverlux LLC.</p>
            <p>
              Smaller images, one bite at a time. Compress JPG and PNG files
              right on your computer, with no uploads and no ads.
            </p>
            <p>
              Free handles up to 30 images per batch and 20 MB per image.
              See your savings and download images individually or as a ZIP.
              An optional one-time Pro upgrade is planned for bigger batches
              and more control.
            </p>
            <div className={styles.cardActions}>
              <Link className={styles.primaryLink} to="/tiny-jpg-png">
                View extension
                <span aria-hidden="true">→</span>
              </Link>
              <TinyJpgPngStoreButton />
            </div>
          </div>
        </article>

        <article className={styles.productCard}>
          <img
            className={styles.productIcon}
            src={tabGroupShareIcon}
            alt="Tab Group Share icon"
            width="120"
            height="120"
          />
          <div className={styles.productSummary}>
            <div className={styles.statusRow}>
            <span className={styles.statusDot} aria-hidden="true" />
              Chrome extension · Free · Available now
            </div>
            <h3>Tab Group Share</h3>
            <p>By Inverlux LLC.</p>
            <p>
              Collect research tabs on a topic, then copy the whole group’s
              titles and URLs into AI prompts, notes, spreadsheets, email, or
              other text tools. Export as Plain Text, Markdown, or JSON.
            </p>
            <p>
              Paste, preview, and confirm imports into an existing or new
              group. Tab order and duplicates stay intact, and existing tabs
              remain open. Processing stays local, with no accounts, backend,
              analytics, or automatic clipboard reading.
            </p>
            <div className={styles.cardActions}>
              <Link className={styles.primaryLink} to="/tab-group-share">
                View extension
                <span aria-hidden="true">→</span>
              </Link>
              <TabGroupShareStoreButton />
            </div>
          </div>
        </article>

        <article className={styles.productCard}>
          <img
            className={styles.productIcon}
            src={appIcon}
            alt="Collapse All for Gmail icon"
          />
          <div className={styles.productSummary}>
            <div className={styles.statusRow}>
              <span className={styles.statusDot} aria-hidden="true" />
              Chrome extension · Free · Available now
            </div>
            <h3>Collapse All for Gmail</h3>
            <p>By Inverlux LLC.</p>
            <p>
              Keep a convenient Collapse all control available in Gmail
              conversation view and collapse expanded messages with one click.
            </p>
            <div className={styles.cardActions}>
              <Link className={styles.primaryLink} to="/gmail-collapse-all">
                View extension
                <span aria-hidden="true">→</span>
              </Link>
              <ChromeWebStoreButton />
            </div>
          </div>
        </article>
      </div>
    </section>
  </>
);

export default AppsHome;
